const { useMemo } = require("react")
const { useSelector } = require("react-redux")
const labels = require("labels");
const object = require("./object");

const {
  reducers,
  listeners,
  browserStorage
} = require("../../../utils/store");
const permissions = require("../../../utils/store/reducers/forms/permissions");

const {
  connect,
  socketCall
} = require("../../../utils/websocket");

const { uuid, checkPassword } = require("../../../utils/crypto")

const workerURL = new URL('../../../utils/store/browser.worker.js', import.meta.url)
global.createWorker = () => new Worker(workerURL);

if ("serviceWorker" in (globalThis.navigator || {})) {
  globalThis.navigator.serviceWorker
    .register(workerURL)
    .then(() => console.log("service worker registered"))
    .catch(console.error)
}

function getLabel(obj, lang, from) {
  let warn = () => console.warn(`Warning: label from ${from}: ${obj}`);
  let label;
  if (obj instanceof Object) {
    if (obj[lang] !== undefined) return label = obj[lang];
    else if (Object.keys(obj).length > 0) {
      label = obj[Object.keys(obj)[0]];
    } else warn();
  } else if (typeof obj === 'string') {
    if (obj.includes(".")) {
      const path = obj.split(".")
      const key = path.pop()
      return labelFromPath(path, key, lang) || obj
    } else {
      console.warn('This label has no language', obj, from);
      return obj;
    }
  } else warn();
  if (!(typeof label === "string")) warn();
  else return label;
}

function getProfile() {
  const { user, list } = global.store.getState();
  if (user.memberUid) {
    let { profile } = list.member[user.memberUid] || {};
    profile = list.profile[profile];
    if (profile) return {
      type: profile.type,
      permissions: profile.permissions
    };
  } return null;
}

function useLabel(label, from) {
  const lang = useSelector(state => state.locale.lang)
  return useMemo(() => getLabel(label, lang, from), [label, lang, from])
}

function labelFromPath(path, key, lang) {
  let _label = object.deepFind(labels, `${path}.${key}`);
  try {
    let label = getLabel(_label, lang, path);
    return label;
  } catch (err) {
    //console.log(path, key);
    console.error(err);
    return null;
  }
}

function arrayEqualityCheck(prev, next) {
  return (
    Array.isArray(prev) === Array.isArray(next) &&
    prev.length === next.length &&
    prev.every((e, i) => next[i] === e)
  )
}

const arraySelectOptions = {
  memoizeOptions: {
    resultEqualityCheck: arrayEqualityCheck
  }
}

const profiles = ["admin", "manager", "member", "guest"];

module.exports = {
  ...object,
  ...require("./file"),
  ...browserStorage,
  uuid,
  setTheme: require("./theme"),
  permissions,
  reducers,
  listeners,
  connect,
  socketCall,
  getLabel,
  checkPassword,
  labelFromPath,
  useLabel,
  arrayEqualityCheck,
  arraySelectOptions,
  hasRight(profile) {
    if (profile) {
      let { user, list } = global.store.getState();
      if (user.memberUid) {
        let member = list.member[user.memberUid];
        if (member) {
          let { type } = list.profile[member.profile] || {};
          if (type) {
            return (
              profiles.includes(type) && profiles.includes(profile) &&
              profiles.indexOf(type) <= profiles.indexOf(profile)
            );
          }
        }
      } else if (user.guestUid) {
        let guest = list.guest[user.guestUid];
        if (guest) {
          let { type } = list.profile[guest.profile] || {};
          if (type) {
            return (
              profiles.includes(type) && profiles.includes(profile) &&
              profiles.indexOf(type) <= profiles.indexOf(profile)
            );
          }
        }
      }
      return false;
    } else return true;
  },
  hasOneOfPermission(permKeys) {
    const { type, permissions } = getProfile() || {};
    if (type && permissions) {
      return permKeys.some(k => permissions[k] === true);
    } else return false;
  },
  // getMainColor(element) {
  //   let fac = new FastAverageColor();
  //   return fac.getColor(element);
  // },
  hexToRgb(hex, opacity) {
    hex = hex.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    if (hex === 'fff') r = g = b = 255;
    else if (hex === '000') r = g = b = 0;
    if (opacity) {
      return `rgba(${r},${g},${b},${opacity})`;
    } else return `rgb(${r},${g},${b})`;
  },
  dateString(date, lang) {
    if (!lang) {
      let { locale } = window.store.getState();
      lang = locale.lang
    }
    const formattedNumber = num => ("0" + num).slice(-2);
    let year = date.getFullYear();
    let month = formattedNumber(date.getMonth() + 1);
    let day = formattedNumber(date.getDate());
    let str = lang === "fr"
      ? `${day}-${month}-${year}`
      : `${year}-${month}-${day}`;
    return str;
  },
  isEmail(value) {
    return value.includes("@")
    // return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value);
  },
  useSocketInterrupted() {
    return useSelector(s => {
      if (!s.simtopy.socketConnectedAt) return false
      if (!s.simtopy.socketDisconnectedAt) return false
      return s.simtopy.socketDisconnectedAt > s.simtopy.socketConnectedAt
    })
  },
}
